<template>

    <div id="app">

        <orientation-warning></orientation-warning>
        <orientation-warning-mobile v-if="isMobile"></orientation-warning-mobile>

        <div class="main" :class="{ 'entering': !hasEntered, 'mobile': isMobile }">

            <div class="interactive" :class="{ 'mobile': isMobile }">

                <overlay v-if="!isMobile">
                    <landing></landing>
                </overlay>

                <div class="err-404" v-if="isMobile && has404">
                    <div class="content">
                        <h1 v-if="has404">{{ status.err404.title }}</h1>
                        <h2 v-if="has404">{{ status.err404.msg }}</h2>
                    </div>
                </div>

                <power-surge-button v-if="!isMobile"></power-surge-button>
                <power-surge-overlay v-if="!isMobile"></power-surge-overlay>

                <interaction-cta></interaction-cta>

                <transition
                    name="fade"
                    mode="out-in"
                    appear>

                    <keep-alive>
                        <router-view v-if="!loadingData"></router-view>
                    </keep-alive>

                </transition>

            </div>

            <transition
                name="fade"
                mode="out-in">

                <sidebar-panel v-if="hasEntered && controlsEntered && !isMobile"></sidebar-panel>

            </transition>

            <transition
                name="footer-transition"
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutDown"
                appear>

                <app-footer v-if="!isMobile"></app-footer>

            </transition>

        </div>


        <sidebar-controls v-if="hasEntered && !isMobile"></sidebar-controls>

    </div>

</template>


<script>

    import OrientationWarning from "./components/OrientationWarning.vue";
    import Overlay from "./components/Overlay.vue";
    import PowerSurgeButton from "./components/PowerSurgeButton.vue";
    import PowerSurgeOverlay from "./components/PowerSurgeOverlay.vue";
    import InteractionCta from "./components/InteractionCTA.vue";
    import SidebarPanel from "./components/SidebarPanel.vue";
    import SidebarControls from "./components/SidebarControls.vue";
    import AppFooter from './components/AppFooter';
    import Landing from "./components/Landing.vue";

    import { config } from './config';
    import OrientationWarningMobile from "./components/OrientationWarningMobile";

    let vm = {};

    export default {

        name: 'app',

        components: {
            OrientationWarningMobile,
            OrientationWarning,
            Overlay,
            PowerSurgeButton,
            PowerSurgeOverlay,
            InteractionCta,
            SidebarPanel,
            SidebarControls,
            AppFooter,
            Landing,
        },

        data() {
            return {
                controlsEntered: false,
                status: {
                    err404: {
                        title: '404 - Page Not Found',
                        msg: 'The page you have requested cannot be found. Please check the URL in the address bar, or click back in your browser to return to your last location.'
                    }
                }
            }
        },

        computed: {

            loading() {
                return this.$dataStore.state.loading;
            },

            loadingData() {
                return this.$dataStore.state.loadingData
            },

            hasEntered() {
                return this.$dataStore.state.interactive.entered;
            },

            isMobile() {
                return this.$md.phone();
            },

            has404() {
                return this.$dataStore.getters.get404Status;
            }

        },

        beforeCreate() {
            if (this.$md.phone()) {
                document.body.classList.add("mobile");
            }
        },

        created() {
            //console.info('%capp::created', 'color:dodgerblue;');

            vm = this;

            vm.fetchData();

            vm.$eventBus.$on('controls:entered', vm.setControlsEntered);
        },
        mounted() {
            //console.info('%capp::mounted', 'color:green;');

            vm = this;
        },
        methods: {

            fetchData() {
                this.$dataStore.dispatch('LOAD_APP_DATA');
            },

            setControlsEntered() {
                this.controlsEntered = true;
            },

            transitionComplete() {
                this.controlsEntered = true;
                this.$eventBus.$emit('residence:resize', 0);
            }

        }
    }

</script>


<style lang="scss">

    @import 'assets/styles/helpers/_variables.scss';
    @import 'assets/styles/main.css';

    #app {
        background-color: $white-100;
        font-family: $font-univers-std;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: rgba(22,22,22, 1.0);
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: row nowrap;
        flex: 1 1 auto;
        position: relative;
    }

    .main {
        height: 100%;
        width: 100%;
        max-width: calc(100% - 70px);
        display: flex;
        flex-flow: column;
        flex: 1 0 auto;
        position: relative;
        z-index: 1;
        transition: all 0.3s ease-in-out;

        &.entering {
            max-width: 100%;
            transition: all 0.3s ease-in-out;
        }

        &.mobile {
            max-width: none;
            height: auto;
        }
    }

    .interactive {
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
        flex: 1 1 auto;
        justify-content: center;
        position: relative;

        &.mobile {
            height: auto;
        }
    }

    .err-404 {
        background-color: var(--color-overlay);
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        position: relative;
        transition: all 0.3s $easeInOutQuad;

        & .content {
            background-color: $white-100;
            height: auto;
            margin: 20px;
            padding: 30px;
            box-shadow: 0 0 3px $black-20;
            position: relative;
            z-index: 5;
            align-self: center;
            transition: all 0.3s $easeInOutQuad;

            & h1 {
                font-family: $font-univers-light-cn;
                font-size: 1.75rem;
                line-height: 1;
                letter-spacing: 0.64px;
                color: var(--color-primary);
                text-transform: uppercase;
                margin: 0 0 16px 0;
            }

            & h2 {
                font-family: $font-univers-std;
                font-size: 1.063rem;
                line-height: 1.25;
                letter-spacing: 0;
                color: $base-text-color;
                margin: 0 10px 0 10px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// App.vue?6ba6c225